<template>
  <div
    v-if="discipline"
    class="DiscForm"
    @click="$emit('close')"
  >
    <div
      class="content-box"
      @click.stop
    >
      <div class="title">
        <h2>{{ $t('AUTHOR.DISCIPLINEEDIT') }}</h2>
      </div>

      <div class="content">
        <form>
          <div class="form-block">
            <div class="fileInput">
              <span>{{ $t('EDITFORM.IMAGE') }}</span>
              <input
                type="file"
                name="imagen"
                @change="loadImage"
              >
            </div>
            <div
              v-for="(field, i) in fields"
              :key="i"
            >
              <component
                :is="componentType(field.type)"
                v-model="field.value"
                :value="field.value"
                :options="field.options"
                :tag="field.name"
                v-bind="{ ...field.attributes, name: field.name}"
              >
                <template #error>
                  <ValidationError
                    :errors="errors"
                    :name="field.name"
                  />
                </template>
              </component>
            </div>
          </div>

          <div class="message">
            <!-- <p
              v-if="created"
              class="created"
            >
              Disciplina guardada correctamente
            </p> -->
          </div>
        </form>

        <div
          v-if="formLoaded"
          class="button-sub"
        >
          <BaseButton @click="submitData">
            {{ $t('BUTTON.SAVE') }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { get } from 'vuex-pathify';
import ValidationError from '@/components/ValidationError.vue';
import ValidationMixin from '@/mixins/ValidationMixin.js';
// import authModule from '@/store/authModule.js';

const COMPONENT_TYPES = {
  select: 'BaseSelectForm',
  input: 'BaseInput',
  text: 'BaseText',
};

export default {
  components: {
    ValidationError,
  },

  mixins: [ValidationMixin],

  props: {
    discipline: {
      type: Object,
      default: undefined,
    },
  },

  data() {
    return {
      formLoaded: false,
      fields: [
        {
          type: 'select', name: 'disciplina', value: undefined, options: [], attributes: { label: this.$t('EDITFORM.DISCIPLINES'), required: 'required' },
        },
        {
          type: 'select', name: 'idioma', value: undefined, options: [], attributes: { label: this.$t('EDITFORM.LENGUAGE'), required: 'required' },
        },
        {
          type: 'select', name: 'condicionlaboral', value: undefined, options: [], attributes: { label: this.$t('EDITFORM.CONDITIONS'), required: 'required' },
        },
        {
          type: 'select', name: 'porcentaje', value: undefined, options: [], attributes: { label: this.$t('EDITFORM.PERCENTAGE'), required: 'required' },
        },
        {
          type: 'text', name: 'descripcion', value: undefined, attributes: { label: 'Descripción', placeholder: this.$t('EDITFORM.DESCRIPTION'), required: 'required' },
        },
        {
          type: 'input', name: 'userdatas_id', value: undefined, attributes: { label: undefined, type: 'hidden' },
        },
      ],
    };
  },
  computed: {
    ...get('authorsModule', [
      'getIdiomas',
      'getCondicionlaboral',
      'getPorcentajes',
      'getCategory',

    ]),

    // getLenguages() {
    //   return this.getIdiomas();
    // },

    // getLen() {
    //   if (!this.getLenguages) return undefined;
    //   return this.getLenguages.reduce((acc, lenguage) => ({ ...acc, [lenguage.id]: lenguage.txt }), {});
    // },

    // getConditions() {
    //   return this.getCondicionlaboral();
    // },

    // getCon() {
    //   if (!this.getConditions) return undefined;
    //   return this.getConditions.reduce((acc, condition) => ({ ...acc, [condition.id]: condition.txt }), {});
    // },

    // getPercentages() {
    //   const percentages = this.getPorcentajes();
    //   return percentages?.reduce((acc, percentage) => ({ ...acc, [percentage.id]: percentage.txt }), {});
    // },

  },


  async created() {
    // calls to store action
    await this.$store.dispatch('authorsModule/fetchDisciplinas');
    await this.$store.dispatch('authorsModule/fetchCondition');
    await this.$store.dispatch('authorsModule/fetchIdiomas');
    await this.$store.dispatch('authorsModule/fetchPorcentaje');

    this.fields = this.loadDisciplinePropertiesOptions();
    // answers.userdatas_id = this.discipline.id;

    if (this.discipline) {
      this.fields = this.loadCurrentDisciplineValues();
    }

    this.formLoaded = true;
  },
  methods: {
    loadImage(event) {
      const input = event.target;

      if (input.files && input.files[0]) {
        this.imagen = input.files[0];
      }
    },
    reloadPage() {
      window.location.reload();
    },

    loadDisciplinePropertiesOptions() {
      const selectOptions = {
        disciplina: this.getDiscipline(),
        idioma: this.getLenguages(),
        condicionlaboral: this.getConditions(),
        porcentaje: this.getPercentages(),
      };

      return this.fields.map((field) => {
        const options = selectOptions[field.name];

        if (!options) return field;
        return ({ ...field, options });
      });
    },

    getDiscipline() {
      const categories = this.getCategory();
      return categories?.reduce((acc, discipline) => ({ ...acc, [discipline.id]: discipline.txt }), {});
    },

    getPercentages() {
      const percentages = this.getPorcentajes();
      return percentages?.reduce((acc, percentage) => ({ ...acc, [percentage.id]: percentage.txt }), {});
    },

    getLenguages() {
      const lenguages = this.getIdiomas();
      return lenguages?.reduce((acc, lenguage) => ({ ...acc, [lenguage.id]: lenguage.txt }), {});
    },

    getConditions() {
      const conditions = this.getCondicionlaboral();
      return conditions?.reduce((acc, condition) => ({ ...acc, [condition.id]: condition.txt }), {});
    },

    // ...

    loadCurrentDisciplineValues() {
      return this.fields.map((field) => {
        const value = this.discipline[field.name];
        if (!value) return field;

        // if (field.attributes.type === 'file') {
        //   //load image
        // }

        if (typeof value !== 'object') return ({ ...field, value });

        return ({ ...field, value: value.id });
      });
    },

    componentType(type) {
      return COMPONENT_TYPES[type];
    },

    async submitData() {
      try {
        if (this.areErrors()) {
          throw new Error(this.$t('FORM.MESSAGE.ERROR.CHECKFIELDS'));
        }

        // const answers = this.fields.reduce((acc, field) => Object.assign(acc, { [field.name]: field.value }), {});
        // answers.userdatas_id = this.discipline.id;

        const currentForm = document.forms[0];
        const formData = new FormData(currentForm);
        formData.set('userdatas_id', this.discipline.id);
        await this.$store.dispatch('authorsModule/editDiscipline', formData);
        // await this.$store.dispatch('authorsModule/editDiscipline', answers);
        this.created = true;
        // this.$emit('close');
        this.reloadPage();
      } catch (error) {
        throw new Error(this.$t('FORM.MESSAGE.ERROR.CHECKFIELDS'));
      }
    },

    /*
    async send(data) {
      await this.$store.dispatch('authModule/register', data);
      // this.$emit('toggle-view', 'login');
    },
    */
  },

};
</script>

<style lang="scss" scoped>
.DiscForm {
  overflow: scroll;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  .content-box {
    padding: 0 4rem;
    background-color: rgb(33, 33, 49);
    border-radius: 1rem;
    width: 900px;
    text-align: center;
    max-height: 95vh;
    overflow-y: auto;

    &:empty {
      background: red;
    }

    .title {
      text-align: center;
      padding: 0.5rem;
      h2 {
        color: var(--color-primary);
        font-size: 2rem;
        font-weight: bold;
        text-transform: uppercase;
        margin: 0;
        padding-top: 1rem;
      }
    }

    .form-block {
      //display: flex;
      flex-wrap: wrap;
      gap: 2rem;
      padding: 1.5rem;
      @media #{$breakpoint-sm-max} {
        padding: 1rem 1rem;
      }
      > * {
        flex: 1 0 auto;
      }
      .fileInput{
        margin:.5rem 0 ;
        display: flex;
        flex-direction: column;
        ::v-deep {
          span {
            align-self: left;
            padding-bottom: 0.5rem;
            width: 300px;
            margin: 0 auto;
            color: white;
          }
          input {
            font-size: var(--font-size-m);
            padding: .3rem 1rem;
            border: solid 2px var(--color-primary);
            border-radius: 10px;
            width: 300px;
            margin: 0 auto;
            background-color: rgb(243, 243, 243);
            &.invalid {
              border: solid 1px red;
            }
          }
        }
      }
      .BaseInput {
        display: flex;
        flex-direction: column;
        ::v-deep {
          label {
            align-self: center;
            padding-bottom: 0.5rem;
            color: white;
          }
          input {
            border: solid 2px var(--color-primary);
            border-radius: 10px;
            width: 350px;
            margin: 0 auto;
          }
        }
      }
      .BaseSelectForm {
        display: flex;
        flex-direction: column;
        width: 100%;
        ::v-deep {
          label {
            padding-top: 1.5rem;
            align-self: center;
            padding-bottom: 0.5rem;
            color: white;
          }
          select {
            border: solid 2px var(--color-primary);
            width: 350px;
            margin: 0 auto;
          }
        }
      }

      .BaseText {
        display: flex;
        flex-direction: column;
        ::v-deep {
          label {
            align-self: center;
            padding-top: 1rem;
            color: white;
          }
          textarea {
            border: solid 2px var(--color-primary);
            width: 500px;
            margin: 0 auto;
          }
        }
      }
    }
    .created {
      //display: flex;
      flex-wrap: wrap;
      padding-top: 2rem;
      padding-left: 30rem;
      @media #{$breakpoint-sm-max} {
        padding: 1rem 9rem;
      }
      > * {
        flex: 1 0 auto;
      }
    }
    .button-sub {
      text-align: center;
      padding: 2rem 0;
    }
  }
}
</style>
